<template>
  <!-- 进入项目的主页 -->
  <div
    class="contain"
    ref="articleListRef"
    @scroll="getScrollTop"
  >

    <div class="title_box">
      <h4>项目主页</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回项目列表</el-button>
    </div>
    <!-- 卡片标题 -->
    <el-card class="box-card">
      <div class="project_title">{{headTitle}}</div>
    </el-card>
    <!-- 牵头专家 -->
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">牵头专家</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryExperts"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputExperts"
          >添加</el-button>
        </div>
      </div>
      <!-- 下边是列表 -->
      <ul class="list_box">
        <div
          class="not-available"
          v-if="expertsLsit.length==0"
        >暂无数据
        </div>
        <li
          v-for="(item,index) in expertsLsit"
          :key="index"
          @click.stop="detailsExperts(item)"
        >
          <div class="headerPictor">
            <!-- <el-image v-if="item.photo=='' "> </el-image> -->
            <el-image v-if="item.photo=='' ">
              <div
                class="r_sbox-img-slot"
                slot="error"
              >暂无</div>
            </el-image>
            <img
              v-else
              :src="item.photo"
            >
          </div>
          <h4 class="name">{{item.name}}</h4>
          <p class="hosptal">{{item.hospital}}</p>
          <div class="tags">
            <el-tag
              type="info"
              :hit="false"
              color="#EEE5FF"
              class="tags-text"
              v-if="item.department_text"
            >{{item.department_text}}</el-tag>
            <el-tag
              type="info"
              :hit="false"
              color="#EEE5FF"
              class="tags-text"
              v-if="item.title"
            >{{item.title}}</el-tag>
          </div>
          <!-- 这里是删除按钮 -->
          <div
            class="delete"
            @click.stop="deleteExperts(item)"
          >
            <i class="iconfont icon-shanchu2"></i>
            <p>删除</p>
          </div>
        </li>
      </ul>
    </el-card>
    <!-- 学协会 -->
    <el-card class="box-card xxh-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">学协会</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryLearn"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputLearn"
          >添加</el-button>
        </div>
      </div>
      <!-- 下边是列表 -->
      <ul class="list_box">
        <div
          class="not-available"
          v-if="learnLsit.length==0"
        >暂无数据
        </div>
        <li
          v-for="(item,index) in learnLsit"
          :key="index"
          @click.stop="detailsLearn(item)"
        >
          <div class="headerPictor">
            <!-- <el-image v-if="item.logo=='' "> </el-image> -->
            <el-image v-if="item.logo=='' ">
              <div
                class="r_sbox-img-slot"
                slot="error"
              >暂无</div>
            </el-image>
            <img
              v-else
              :src="item.logo"
            >
          </div>
          <h4 class="name">{{item.name}}</h4>
          <p class="hosptal level">级别：{{item.level_text}}</p>
          <!-- 这里是删除按钮 -->
          <div
            class="delete"
            @click.stop="deleteLearn(item)"
          >
            <i class="iconfont icon-shanchu2"></i>
            <p>删除</p>
          </div>
        </li>
      </ul>
    </el-card>
    <!-- 基金会 -->
    <el-card class="box-card xxh-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">基金会</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryFunds"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputFunds"
          >添加</el-button>
        </div>
      </div>
      <!-- 下边是列表 -->
      <ul class="list_box">
        <div
          class="not-available"
          v-if="fundsLsit.length==0"
        >暂无数据
        </div>
        <li
          v-for="(item,index) in fundsLsit"
          :key="index"
          @click.stop="detailsFunds(item)"
        >
          <div class="headerPictor">
            <!-- <el-image v-if="item.logo=='' "> </el-image> -->
            <el-image v-if="item.logo=='' ">
              <div
                class="r_sbox-img-slot"
                slot="error"
              >暂无</div>
            </el-image>
            <img
              v-else
              :src="item.logo"
            >
          </div>
          <h4 class="name">{{item.name}}</h4>
          <p class="hosptal level">级别：{{item.level_text}}</p>
          <!-- 这里是删除按钮 -->
          <div
            class="delete"
            @click.stop="deleteFunds(item)"
          >
            <i class="iconfont icon-shanchu2"></i>
            <p>删除</p>
          </div>
        </li>
      </ul>
    </el-card>
    <!-- 赞助企业 -->
    <el-card class="box-card xxh-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">赞助企业</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryCompanies"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputCompanies"
          >添加</el-button>
        </div>
      </div>
      <!-- 下边是列表 -->
      <ul class="list_box">
        <div
          class="not-available"
          v-if="companiesList.length==0"
        >暂无数据
        </div>
        <li
          v-for="(item,index) in companiesList"
          :key="index"
          @click.stop="detailsCompanies(item)"
        >
          <div class="headerPictor">
            <!-- <el-image v-if="item.logo=='' "> </el-image> -->
            <el-image v-if="item.logo=='' ">
              <div
                class="r_sbox-img-slot"
                slot="error"
              >暂无</div>
            </el-image>
            <img
              v-else
              :src="item.logo"
            >
          </div>
          <h4 class="name">{{item.name}}</h4>
          <p class="hosptal level">行业细分:{{item.i_id_text}}</p>
          <!-- 这里是删除按钮 -->
          <div
            class="delete"
            @click.stop="deleteCompanies(item)"
          >
            <i class="iconfont icon-shanchu2"></i>
            <p>删除</p>
          </div>
        </li>
      </ul>
    </el-card>
    <!-- 执行方 -->
    <el-card class="box-card xxh-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">执行方</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryImplementation"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputImplementation"
          >添加</el-button>
        </div>
      </div>
      <!-- 下边是列表 -->
      <ul class="list_box">
        <div
          class="not-available"
          v-if="ImplementationList.length==0"
        >暂无数据
        </div>
        <li
          v-for="(item,index) in ImplementationList"
          :key="index"
          @click.stop="detailsImplementation(item)"
        >
          <div class="headerPictor">
            <!-- <el-image v-if="item.logo=='' "></el-image> -->
            <el-image v-if="item.logo=='' ">
              <div
                class="r_sbox-img-slot"
                slot="error"
              >暂无</div>
            </el-image>
            <img
              v-else
              :src="item.logo"
            >
          </div>
          <h4 class="name">{{item.name}}</h4>
          <p class="hosptal level">分类：{{item.c_id_text}}</p>
          <!-- 这里是删除按钮 -->
          <div
            class="delete"
            @click.stop="deleteImplementation(item)"
          >
            <i class="iconfont icon-shanchu2"></i>
            <p>删除</p>
          </div>
        </li>
      </ul>
    </el-card>
    <!-- 会议进度 -->
    <el-card class="box-card xxh-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">会议进度</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryConference"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputConference"
          >添加</el-button>
        </div>
      </div>
      <!-- 这里是表格 -->
      <div
        class="not-available"
        v-if="ConferenceList.length==0"
      >暂无数据
      </div>
      <div v-if="ConferenceList.length!=0">
        <el-table
          :data="ConferenceList"
          style="width: 100%"
          @row-click="detailsConference"
        >
          <el-table-column
            prop="name"
            label="会议名称"
            min-width="40%"
          >
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="起止时间"
            min-width="40%"
          >
          </el-table-column>
          <el-table-column
            prop="end_time"
            label="截止时间"
            min-width="40%"
          >
          </el-table-column>
          <el-table-column
            prop="c_id_text"
            label="会议类别"
            min-width="20%"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="80"
          >
            <template slot-scope="scope">
              <i
                class="iconfont icon-shanchu2 cursor-icon"
                @click.stop="deleteConference(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <!-- 共识撰写 -->
    <el-card class="box-card xxh-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">共识撰写</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryConsensus"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputConsensus"
          >添加</el-button>
        </div>
      </div>
      <!-- 这里是表格 -->
      <div
        class="not-available"
        v-if="ConsensusList.length==0"
      >暂无数据
      </div>
      <div v-if="ConsensusList.length!=0">
        <el-table
          :data="ConsensusList"
          style="width: 100%"
          @row-click="detailsConsensus"
        >
          <el-table-column
            prop="name"
            label="文稿名称"
            min-width="33%"
          >
          </el-table-column>
          <el-table-column
            label="执笔人"
            min-width="50%"
            prop="writer_str"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="80"
          >
            <template slot-scope="scope">
              <!-- 这里是删除按钮 -->
              <i
                class="iconfont icon-shanchu2 cursor-icon"
                @click.stop="deleteConsensus(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <!-- 共识投票 -->
    <el-card class="box-card xxh-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">共识投票</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryVote"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputVote"
          >添加</el-button>
        </div>
      </div>
      <!-- 这里是表格 -->
      <div
        class="not-available"
        v-if="VoteList.length==0"
      >暂无数据
      </div>
      <div v-if="VoteList.length!=0">
        <el-table
          :data="VoteList"
          style="width: 100%"
          @row-click="detailsVote"
        >
          <el-table-column
            prop="name"
            label="项目名称"
            min-width="39%"
          >
          </el-table-column>
          <el-table-column
            prop="end_time"
            label="投票截止时间"
            min-width="30%"
          >
          </el-table-column>
          <el-table-column
            prop="total_number"
            label="已投票人数/总投票人数"
            min-width="30%"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="80"
          >
            <template slot-scope="scope">
              <i
                class="iconfont icon-shanchu2 cursor-icon"
                @click.stop="deleteVote(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <!-- 发表期刊 -->
    <el-card class="box-card fbqk-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">发表期刊</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryPeriodicals"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputPeriodicals"
          >添加</el-button>
        </div>
      </div>
      <!-- 下边是列表  -->
      <ul class="list_box">
        <div
          class="not-available"
          v-if="PeriodicalsList.length==0"
        >暂无数据
        </div>
        <li
          v-for="(item,index) in PeriodicalsList"
          :key="index"
          @click.stop="detailsPeriodicals(item)"
        >
          <!-- headerPictor headerPictor-img-->
          <div class="headerPictor-img">
            <!-- <el-image v-if="item.logo=='' "> </el-image> -->
            <el-image v-if="item.logo=='' ">
              <div
                class="r_sbox-img-slot"
                slot="error"
              >暂无</div>
            </el-image>
            <img
              v-else
              :src="item.logo"
            >
          </div>
          <div class="line"></div>
          <div class="content">
            <h4 class="PeriodicalsList-name">
              {{item.name}}
            </h4>
            <div
              class="delete"
              @click.stop="deletePeriodicals(item)"
            >
              <i class="iconfont icon-shanchu2"></i>
              <p>删除</p>
            </div>
          </div>
        </li>
      </ul>
    </el-card>
    <!-- 期刊抽印本 -->
    <el-card class="box-card xxh-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">期刊抽印本</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryExtractionPrinting"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputExtractionPrinting"
          >添加</el-button>
        </div>
      </div>
      <!-- 这里是表格 -->
      <div
        class="not-available"
        v-if="ExtractionPrintingList.length==0"
      >暂无数据
      </div>
      <div v-if="ExtractionPrintingList.length!=0">
        <el-table
          :data="ExtractionPrintingList"
          style="width: 100%"
          @row-click="detailsExtractionPrinting"
        >
          <el-table-column
            prop="name"
            label="共识题目"
            min-width="40%"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="nums"
            label="册数"
            min-width="40%"
          >
          </el-table-column> -->
          <el-table-column
            prop="journal_type_text"
            label="期刊类型"
            min-width="60%"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="80"
          >
            <template slot-scope="scope">
              <i
                class="iconfont icon-shanchu2 cursor-icon"
                @click.stop="deleteExtractionPrinting(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <!-- 媒体发布 -->
    <el-card class="box-card xxh-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">媒体发布</span>
        <div class="operation">
          <el-button
            style="background: #484c7f"
            size="small"
            type="primary"
            @click="primaryMedia"
          >选择</el-button>
          <el-button
            size="small"
            type="primary"
            @click="inputMedia"
          >添加</el-button>
        </div>
      </div>
      <!-- 这里是表格 -->
      <div
        class="not-available"
        v-if="MediaList.length==0"
      >暂无数据
      </div>
      <div v-if="MediaList.length!=0">
        <el-table
          :data="MediaList"
          style="width: 100%"
          @row-click="detailsMedia"
        >
          <el-table-column
            prop="name"
            label="媒体名称"
            min-width="40%"
          >
          </el-table-column>
          <el-table-column
            prop="c_id_text"
            label="分类"
            min-width="40%"
          >
          </el-table-column>
          <el-table-column
            prop="p_id_text"
            label="平台类型"
            min-width="20%"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="80"
          >
            <template slot-scope="scope">
              <i
                class="iconfont icon-shanchu2 cursor-icon"
                @click.stop="deleteMedia(scope.row)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <!-- 项目服务 -->
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
      >
        <span class="title">项目服务</span>
      </div>
      <div>
        <el-checkbox-group v-model="checkList">
          <el-checkbox
            :label="item.id"
            v-for="item in services"
            :key="item.id"
          >
            <div class="services-box">
              <div class="services-img"><img :src="item.img"></div>
              <div class="services-text">{{item.name}}</div>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <!-- 提交的按钮 -->
      <div class="uploads">
        <el-button
          type="primary"
          size="small"
          @click="SubmitProjectServices"
        >提交</el-button>
      </div>
    </el-card>
    <!-- 返回顶部 -->
    <div
      v-if="backTopIsShow"
      class="back-top"
      @click="backTop"
    >
      <i class="el-icon-caret-top"></i>
    </div>
  </div>
</template>    
  
<script>
export default {
  name: 'HomeProject',
  data () {
    return {
      headTitle: '',
      expertsLsit: [],
      learnLsit: [],
      fundsLsit: [],
      companiesList: [],
      ImplementationList: [],
      PeriodicalsList: [],
      ConferenceList: [],
      ConsensusList: [],
      ConsensusListPenmanship: '',
      VoteList: [],
      ExtractionPrintingList: [],
      MediaList: [],
      services: [],
      checkList: [],
      backTopIsShow: false,
      scrollComplete: true
    }
  },
  mounted () {
    // this.getScrollTop()
  },
  activated () {
    this.headTitle = this.$route.query.title
    //* 列表              
    this.getExpertsList()
    this.getLearnList()
    this.getFundsList()
    this.getCompaniesList()
    this.getImplementationList()
    this.getPeriodicalsList()
    this.getConferenceList()
    this.getConsensusList()
    this.getVoteList()
    this.getExtractionPrintingList()
    this.getMediaList()
    this.getcatelist()
    this.getProjectServicesLsit()
    //1、this.$nextTick此处没起到作用， 2、设置scrollTop 也会触发onscroll事件，
    this.scrollComplete = false;
    let scrollTop = sessionStorage.getItem('scrollTop')
    setTimeout(() => {
      this.$refs.articleListRef.scrollTop = scrollTop
      this.scrollComplete = true
    }, 20);
  },
  methods: {
    //! 获取滚动高度
    getScrollTop (e) {
      //超过4490就会回跳   4490 
      if (this.scrollComplete) {
        if (e.target.scrollTop >= 1300) {
          this.backTopIsShow = true
        } else {
          this.backTopIsShow = false
        }
        sessionStorage.setItem('scrollTop', e.target.scrollTop)
      }
    },
    //? 选择专家 
    primaryExperts () {
      this.$router.push({
        path: '/ExpertDatabase', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //? 录入专家
    inputExperts () {
      this.$router.push({
        path: '/expertEditor',
        query: {
          id: '',
          project_id: this.$route.query.id,
        }
      })
    },
    //? 获取专家列表
    async getExpertsList () {
      const { data: data } = await this.$http.post('expert/list', { project_id: this.$route.query.id })
      this.expertsLsit = data.data
    },
    //? 删除专家
    deleteExperts (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'expert_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getExpertsList()
      }).catch(() => { })
    },
    //? 专家详细 
    detailsExperts (item) {
      this.$router.push({
        path: '/expertDetail', query: {
          id: item.id,
        }
      })
    },
    //* 选择学协会 
    primaryLearn () {
      this.$router.push({
        path: '/XfoundationDatabase', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //* 获取学协会列表 
    async getLearnList () {
      const { data: data } = await this.$http.post('aprender/list', { project_id: this.$route.query.id })
      this.learnLsit = data.data
    },
    //* 删除学协会
    deleteLearn (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'aprender_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getLearnList()
      }).catch(() => { })
    },
    //* 录入学协会
    inputLearn () {
      this.$router.push({
        path: '/foundationEditor',
        query: {
          title: '录入学协会',
          id: '',
          name: '学协会名称',
          inputName: '请输入学协会名称',
          cate_id: 310,
          api: 'aprender',
          project_id: this.$route.query.id,
        }
      })
    },
    //* 学协会详情 
    detailsLearn (item) {
      this.$router.push({
        path: '/foundationDetail', query: {
          id: item.id,
          path: 'aprender',
        }
      })
    },
    //1 选择基金会
    primaryFunds () {
      this.$router.push({
        path: '/JfoundationDatabase', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //1 获取基金会列表  
    async getFundsList () {
      const { data: data } = await this.$http.post('foundataion/list', { project_id: this.$route.query.id })
      this.fundsLsit = data.data
    },
    //1 删除基金会
    deleteFunds (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'foundation_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getFundsList()
      }).catch(() => { })
    },
    //1 录入基金会
    inputFunds () {
      this.$router.push({
        path: '/foundationEditor',
        query: {
          title: '录入基金会',
          id: '',
          name: '基金会名称',
          inputName: '请输入基金会名称',
          cate_id: 309,
          api: 'foundation',
          project_id: this.$route.query.id,
        }
      })
    },
    //1 基金会详情 
    detailsFunds (item) {
      this.$router.push({
        path: '/foundationDetail', query: {
          id: item.id,
          path: 'foundation'
        }
      })
    },
    //2 选择企业
    primaryCompanies () {
      this.$router.push({
        path: '/companyDatabase', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //2 获取企业列表  
    async getCompaniesList () {
      const { data: data } = await this.$http.post('empresa/list', { project_id: this.$route.query.id })
      this.companiesList = data.data
    },
    //2 删除企业
    deleteCompanies (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'empresa_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getCompaniesList()
      }).catch(() => { })
    },
    //2 录入企业
    inputCompanies () {
      this.$router.push({
        path: '/companyEditor',
        query: {
          id: '',
          project_id: this.$route.query.id,
        }
      })
    },
    //2 企业详情 
    detailsCompanies (item) {
      this.$router.push({
        path: '/companydetail', query: {
          id: item.id,
        }
      })
    },
    //3 选择执行方  
    primaryImplementation () {
      this.$router.push({
        path: '/zxflist', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //3 获取执行方列表
    async getImplementationList () {
      const { data: data } = await this.$http.post('executor/list', { project_id: this.$route.query.id })
      this.ImplementationList = data.data
    },
    //3 删除执行方
    deleteImplementation (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'executor_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getImplementationList()
      }).catch(() => { })
    },
    //3 录入执行方
    inputImplementation () {
      this.$router.push({
        path: '/zxfEditor',
        query: {
          id: '',
          project_id: this.$route.query.id,
        }
      })
    },
    //3 执行方详情 
    detailsImplementation (item) {
      this.$router.push({
        path: '/zxfdetail', query: {
          id: item.id,
        }
      })
    },
    //4 选择期刊   
    primaryPeriodicals () {
      this.$router.push({
        path: '/periodicalList', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //4 获取期刊列表  
    async getPeriodicalsList () {
      const { data: data } = await this.$http.post('periodical/list', { project_id: this.$route.query.id })
      this.PeriodicalsList = data.data
    },
    //4 删除期刊
    deletePeriodicals (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'per_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getPeriodicalsList()
      }).catch(() => { })
    },
    //4 录入期刊 
    inputPeriodicals () {
      this.$router.push({
        path: '/periodicalEditor',
        query: {
          id: '',
          project_id: this.$route.query.id,
        }
      })
    },
    //4 期刊详情 
    detailsPeriodicals (item) {
      this.$router.push({
        path: '/periodicalDetail',
        query: {
          id: item.id
        }
      })
    },
    //5 选择会议 
    primaryConference () {
      this.$router.push({
        path: '/meetingList', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //5 获取会议列表   
    async getConferenceList () {
      const { data: data } = await this.$http.post('meeting_edit/list', { project_id: this.$route.query.id })
      this.ConferenceList = data.data
    },
    //5 录入会议 
    inputConference () {
      this.$router.push({
        path: '/editorMeeting',
        query: {
          id: '',
          project_id: this.$route.query.id,
        }
      })
    },
    //5 删除会议
    deleteConference (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'meeting_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getConferenceList()
      }).catch(() => { })
    },
    //5 会议详情 
    detailsConference (item) {
      this.$router.push({
        path: '/conferenceDetails',
        query: {
          id: item.id
        }
      })
    },
    //6 选择共识  
    primaryConsensus () {
      this.$router.push({
        path: '/gongshiList', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //6 获取共识  
    async getConsensusList () {
      const { data: data } = await this.$http.post('consensus/list', { project_id: this.$route.query.id })
      this.ConsensusList = data.data
    },
    //6 录入共识 
    inputConsensus () {
      this.$router.push({
        path: '/editorGongshi',
        query: {
          id: '',
          project_id: this.$route.query.id,
        }
      })
    },
    //6 删除共识
    deleteConsensus (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'consensus_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getConsensusList()
      }).catch(() => { })
    },
    //6 共识详情 
    detailsConsensus (item) {
      this.$router.push({
        path: '/consensusDetails',
        query: {
          id: item.id
        }
      })
    },
    //7 选择投票  
    primaryVote () {
      this.$router.push({
        path: '/voteList', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //7 获取投票  
    async getVoteList () {
      const { data: data } = await this.$http.post('vote_edit/list', { project_id: this.$route.query.id })
      this.VoteList = data.data
    },
    //7 录入投票  
    inputVote () {
      this.$router.push({
        path: '/editorVote',
        query: {
          id: '',
          project_id: this.$route.query.id,
        }
      })
    },
    //7 删除投票  
    deleteVote (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'vote_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getVoteList()
      }).catch(() => { })
    },
    //7 投票详情 
    detailsVote (item) {
      this.$router.push({
        path: '/voteDetail',
        query: {
          id: item.id
        }
      })
    },
    //8 选择抽印     
    primaryExtractionPrinting () {
      this.$router.push({
        path: '/offprintList', query: {
          project_id: this.$route.query.id,
          title: this.$route.query.title
        }
      })
    },
    //8 获取投票  
    async getExtractionPrintingList () {
      const { data: data } = await this.$http.post('periodical_copy/list', { project_id: this.$route.query.id })
      this.ExtractionPrintingList = data.data
    },
    //8 录入抽印  
    inputExtractionPrinting () {
      this.$router.push({
        path: '/editoroffprint',
        query: {
          id: '',
          project_id: this.$route.query.id,
          title: this.$route.query.title
        }
      })
    },
    //8 删除抽印  
    deleteExtractionPrinting (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'copy_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getExtractionPrintingList()
      }).catch(() => { })
    },
    //8 抽印详情 
    detailsExtractionPrinting (item) {
      this.$router.push({
        path: '/viewDrawmarks',
        query: {
          id: item.id
        }
      })
    },
    //9 选择媒体 mediaDatabase
    primaryMedia () {
      this.$router.push({
        path: 'mediaDatabase', query: {
          project_id: this.$route.query.id,
        }
      })
    },
    //9 录入媒体  
    inputMedia () {
      this.$router.push({
        path: '/mediaEditor',
        query: {
          id: '',
          project_id: this.$route.query.id,
        }
      })
    },
    //9 获取媒体列表
    async getMediaList () {
      const { data: data } = await this.$http.post('media/list', { project_id: this.$route.query.id })
      this.MediaList = data.data
    },
    //9 删除媒体列表
    deleteMedia (item) {
      this.$confirm('您是否要删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post('project/delete', {
          project_id: this.$route.query.id,
          type: 'media_id',
          id: item.id
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getMediaList()
      }).catch(() => { })
    },
    //9 媒体详情 
    detailsMedia (item) {
      this.$router.push({
        path: '/mediaDetail', query: {
          id: item.id,
        }
      })
    },
    //0 分类列表
    async getcatelist () {
      const { data: data } = await this.$http.post('/cate/list', { type: 14 })
      this.services = data.data
    },
    //0 项目服务列表
    async getProjectServicesLsit () {
      const { data: data } = await this.$http.post('service/list', { project_id: this.$route.query.id })
      this.checkList = data.data
    },
    //0 提交项目服务
    async SubmitProjectServices () {
      if (this.checkList.length != 0) {
        const { data: data } = await this.$http.post('p/service', {
          project_id: this.$route.query.id,
          service_id: this.checkList
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getProjectServicesLsit()
      } else {
        this.$message.error('请选择项目服务');
      }
    },
    //返回
    backProject () {
      this.$router.back()
    },
    //返回顶部
    backTop () {
      window.clearInterval(tmie)
      let tmie = setInterval(() => {
        if (this.$refs.articleListRef.scrollTop <= 0) {
          window.clearInterval(tmie)
        } else {
          this.$refs.articleListRef.scrollTop -= 300
        }
      }, 17)
    }
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  transition: 0.4s all;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .bigTitle {
    font-size: 28px;
    color: #212529;
  }
  .line {
    width: 100%;
    height: 1px;
    background: #e8e8e8;
    margin-top: 20px;
  }
  .box-card {
    margin-top: 23px;
  }
  .project_title {
    text-align: center;
    color: #212529;
    font-size: 16px;
    font-weight: bold;
    word-break: break-all;
  }
  .clearfix {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      color: #212529;
      font-weight: bold;
    }
    .operation {
      .el-button {
        margin-left: 10px;
      }
    }
  }
  .list_box {
    width: 80%;
    min-width: 980px;
    margin-top: 24px;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
    flex-wrap: wrap;

    li {
      width: 30%;
      border: 1px solid #f0f0f0;
      margin-bottom: 40px;
      padding-bottom: 10px;
      cursor: pointer;
      transition: 0.3s all;
      .headerPictor {
        width: 109px;
        height: 109px;
        margin: 0 auto;
        margin-top: 20px;
        border-radius: 50% !important;
        overflow: hidden !important;
        img {
          width: 100%;
          height: 100%;
        }
        /deep/ .el-image {
          width: 100% !important;
          height: 100% !important;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #f5f7fa;
          .r_sbox-img-slot {
            font-size: 14px;
            color: #c0c4cc;
            vertical-align: middle;
          }
        }
      }

      .headerPictor-img {
        width: 138px;
        height: 138px;
        margin-left: 23px;
        margin-top: 25px;
        // border-radius: 50% !important;
        overflow: hidden !important;
        img {
          width: 100%;
          height: 100%;
        }
        /deep/ .el-image {
          width: 100% !important;
          height: 100% !important;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #f5f7fa;
          .r_sbox-img-slot {
            font-size: 14px;
            color: #c0c4cc;
            vertical-align: middle;
          }
        }
      }
      .name {
        text-align: center;
        margin: 0 auto;
        margin-top: 20px;
        color: #212529;
        width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .hosptal {
        text-align: center;
        margin: 0 auto;
        margin-top: 10px;
        width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tags {
        width: 80%;
        margin: 0 auto;
        margin-top: 20px;
        text-align: center;
        .el-tag {
          margin-right: 10px;
        }
        .tags-text {
          width: 70px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .delete {
        text-align: center;
        margin-top: 10px;
        i {
          font-size: 20px;
          color: #f12937;
        }
        p {
          font-size: 11px;
          color: #212529;
        }
      }
      &:hover {
        transform: translate3d(0, -4px, 0);
      }
    }
  }
  // 学协会的样式
  .xxh-card {
    .list_box {
      .headerPictor {
        border-radius: 0;
      }
      li {
        .level {
          margin-top: 37px;
        }
      }
    }
    .el-table {
      margin-bottom: 20px;
      &::before {
        height: 0;
      }
      /deep/ tbody {
        tr {
          .el-table__cell {
            border: 0 none;
          }
        }
      }
    }
  }
  .fbqk-card {
    .list_box {
      li {
        width: 433px;
        height: 193px;
        border: 1px solid #f0f0f0;
        display: flex;
        .headerPictor {
          width: 138px;
          height: 138px;
          margin-left: 23px;
          margin-top: 25px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .line {
          width: 1px;
          height: 150px;
          background: #e9e9e9;
          margin-left: 22px;
        }
        .content {
          flex: 1;
          h4 {
            margin: 0 auto;
            margin-top: 22px;
          }
          .PeriodicalsList-name {
            width: 188px;
            height: 105px;
            font-size: 14px;
            color: #212529;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 400;
            line-height: 21px;
          }
        }
      }
    }
  }
  /deep/.is-checked {
    .el-checkbox__label {
      color: #212529;
    }
  }
  .uploads {
    margin-top: 70px;
    .el-button {
      background: #484c7f;
    }
  }

  /deep/ .el-card__header {
    border: none !important;
  }

  .not-available {
    padding-bottom: 50px;
    font-size: 13px;
    color: #8588ae;
    text-align: center;
  }
  .icon-shanchu2 {
    color: #f12937;
  }
  .cursor-icon {
    cursor: pointer;
  }
  .services-box {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 2px;
    left: 0;

    .services-img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .services-text {
      font-size: 12px;
      color: #212529;
    }
  }

  /* 设置带边框的checkbox，选中后边框的颜色 */
  /deep/.is-bordered.is-checked {
    border-color: #484c7f;
  }

  /* 设置选中后的文字颜色 */
  /deep/.myRedCheckBox .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #484c7f;
  }

  /* 设置选中后对勾框的边框和背景颜色 */
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #484c7f;
    background-color: #484c7f;
  }

  /* 设置checkbox获得焦点后，对勾框的边框颜色 */
  /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #484c7f;
  }

  /* 设置鼠标经过对勾框，对勾框边框的颜色 */
  /deep/ .myRedCheckBox .el-checkbox__inner:hover {
    border-color: #484c7f;
  }

  //返回顶部
  .back-top {
    position: fixed;
    bottom: 100px;
    right: 27px;

    background-color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #409eff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
    cursor: pointer;
    z-index: 999;
  }

  /deep/ .el-table__row:hover {
    cursor: pointer;
  }
}
</style>
 